'use strict';

(() => {
    const util = angular.module('gymsystem.util');

    util.controller('AdyenTerminalCtrl', ['$scope', 'options', 'live', 'server', '$filter', function($scope, options, live, server, $filter) {
        const channel2 = options.channel2;
        const ref = options.ref;

        $scope.statusText = 'Connecting to terminal';
        $scope.preventFromClosing = true;
        $scope.canCancel = false;
        $scope.statusPaid = false;
        $scope.statusError = false;
        $scope.tipAmount = null;
        $scope.totalAmount = null;

        live.channel2($scope, channel2, function (response) {
            if (response.type == 'failed') {
                $scope.statusError = true;
                let message = response.message;
                if (message == 'Busy') message = 'Terminal is busy';
                $scope.statusText = message;
                $scope.preventFromClosing = false;
                $scope.canCancel = false;
                options.reject();
            } else if (response.type == 'internal-error') {
                $scope.statusText = `Error`;
                $scope.preventFromClosing = false;
                $scope.canCancel = false;
                options.reject();
            } else if (response.type == 'wait') {
                if (options.purchase) {
                    $scope.statusText = 'Waiting for payment';
                } else {
                    $scope.statusText = 'Waiting for refund';
                }
                $scope.canCancel = true;
            } else if (response.type == 'print-error') {
                $scope.statusText = response.reason == 'no-paper' ? 'Receipt could not be printed: printer is out of paper' : 'Receipt could not be printed';
            } else if (response.type == 'paid') {
                $scope.statusPaid = true;
                $scope.tipAmount = Number(response.tip_amount) || null;
                $scope.totalAmount = Number(response.total_amount) || null;
                if (response.connection_ok) $scope.connectionError = false;
                $scope.statusText = 'Payment was successful, checkout is finishing';
                $scope.canCancel = false;
                $scope.preventFromClosing = false;
                options.resolve();
            } else if (response.type == 'paid-no-checkout') {
                $scope.statusText = 'Payment was received, but checkout could not be completed automatically. Manual handling is required.';
            } else if (response.type == 'cancelled') {
                $scope.statusError = true;
                $scope.statusText = 'Cancelled';
                $scope.preventFromClosing = false;
                $scope.canCancel = false;
                options.reject();
            } else if (response.type == 'connection-error') {
                $scope.connectionError = true;
                $scope.canCancel = false;
            } else if (response.type == 'ccu-error') {
                $scope.statusText = 'CCUFAIL';
                $scope.preventFromClosing = false;
                $scope.canCancel = false;
                options.reject({
                    type: 'ccu',
                    bundle_id: response.bundle_id
                });
            } else if (response.type == 'done') {
                $scope.statusText = 'Success';
                $scope.preventFromClosing = false;
                $scope.canCancel = false;
                options.resolve();
            }
            $scope.$apply();
        });

        $scope.cancel = () => {
            $scope.canCancel = false;
            server.post('/api/adyen/terminal/cancel', { ref }).catch(() => $scope.canCancel = true);
        };

        $scope.close = () => {
            if(!$scope.preventFromClosing) {
                $scope.$dismiss();
                options.reject();
            }
        };

    }]);
})();
